import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import { Card, CardHeader, CardBody, Row, Col, Button, FormGroup, Label, Input, InputGroup, InputGroupAddon, } from 'reactstrap';

import TooltipItem from "components/Varios/Tooltip.js";
import CardTelefono from "components/Varios/CardTelefonos.js";
import SelectItem from "components/Varios/select.js";
import Icon from "components/Varios/Icons.js";
import { alertService } from 'components/Varios/alert_service.js';

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const API_URL = configData.SERVER_URL

var codigosArea = {}

export const ID_PAIS_ECUADOR = 1;

type Area_ID = {
    idpais: number,
    codigoArea: string
}

const tiposTelefono = [
    { label: 'Celular personal', value: "C" },
    { label: 'Domicilio convencional', value: "D" },
    { label: 'Trabajo', value: "T" },
];

export class TelefonosData {
    idpersona: number = 0;
    idtelefono: number = 0;
    tipotelefono: string = "C";
    idpais: number = ID_PAIS_ECUADOR;
    codigopais: string = "593";
    codigoarea: string = "";
    numerotelefono: string = "";
    version: number = 0;
    ext: string = ""
    idprovincia: number = 0;

}

interface TelefonosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean,
    dtoData: TelefonosData;
    telefonosDataList: TelefonosData[];
    codigosPaisList: Array<any>;
    matchidPaisArea: Array<Area_ID>;
    codigoAreaList: Array<any>;
    tiposTelefonoList: Array<any>;
    error: null;
    readOnlyCodigoPais: boolean;
    readOnlyCodigoProvincia: boolean;
}

export class Telefonos extends React.Component<RouteComponentProps<{}>, TelefonosDataState> {
    constructor(props) {
        super(props);
        this.state = { currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new TelefonosData(), codigosPaisList: [], matchidPaisArea: [], codigoAreaList: [], telefonosDataList: [], tiposTelefonoList: [], error: null, readOnlyCodigoPais: true, readOnlyCodigoProvincia: false };

        // This binding is necessary to make "this" work in the callback
        //this.onClickEdit = this.onClickEdit.bind(this);
        this.cargarTelefonos = this.cargarTelefonos.bind(this);
        this.cargarCodigoPais = this.cargarCodigoPais.bind(this);
        this.cargarCodigoArea = this.cargarCodigoArea.bind(this);
        //this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectChangeTipo = this.handleSelectChangeTipo.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarTelefonos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        //this.setState({
                        //    codigosPaisList: result.entTabla.map(d => (
                        //        {
                        //        "value": d.idpais,
                        //        "label": d.nombre
                        //    })),
                        //    loading: false
                        //});

                        var paises: any[] = []
                        var match_paises_area: Array<Area_ID> = []
                        for (var i = 0; i < result.entTabla.length; i++) {
                            if (result.entTabla[i].codigotelefonico) {
                                paises.push({
                                    "value": result.entTabla[i].idpais,
                                    "label": result.entTabla[i].nombre + " - " + result.entTabla[i].codigotelefonico
                                })
                                match_paises_area.push({
                                    idpais: result.entTabla[i].idpais,
                                    codigoArea: result.entTabla[i].codigotelefonico
                                })

                            }


                            //codigosTelefonicos[result.entTabla[i].idpais] = (result.entTabla[i].codigotelefonico ? result.entTabla[i].codigotelefonico.trim() : "");
                            //if (result.entTabla[i].codigotelefonico) {
                            //    codigosPais[result.entTabla[i].codigotelefonico.trim()] = result.entTabla[i].idpais
                            //}

                        }

                        this.setState({
                            loading: false,
                            codigosPaisList: paises,
                            matchidPaisArea: match_paises_area
                        });

                        this.cargarCodigoPais("593", false);

                    } else if (result.strEstado === "N") {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los países.")
                    }
                    else {
                        alertService.error("Ocurrió un error: " + result)
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        codigosPaisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

    }

    //API PARA OBTENER TELEFONOS DE PERSONA
    cargarTelefonos() {
        fetch(API_URL + "DatosTelefono/TelefonoByIdPersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            telefonosDataList: result.entTabla,
                            tiposTelefonoList: tiposTelefono,
                            loading: false,
                            loadingList: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los teléfonos de la persona.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        telefonosDataList: []
                    });
                    alertService.error("Ocurrió un error.")
                }
            )
    }

    cargarCodigoPais(codigopais, change = true) {
        var dto = this.state.dtoData;
        dto["codigopais"] = codigopais;
        if (change) {
            dto["codigoarea"] = "";
        }

        this.setState({
            dtoData: dto,
        });

        this.handleSelectChangeTipo(dto.tipotelefono)

        if (codigopais === "593") {
            fetch(API_URL + "DatosGenerales/ProvinciaIdPais/1")
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.strEstado === "S") {

                            var provincias: any[] = []
                            var codigosRepetidos = {}
                            for (var i = 0; i < result.entTabla.length; i++) {
                                if (result.entTabla[i].codigotelefono) {
                                    if (Object.keys(codigosRepetidos).includes(result.entTabla[i].codigotelefono)) {
                                        codigosRepetidos[result.entTabla[i].codigotelefono] = codigosRepetidos[result.entTabla[i].codigotelefono] + "/" + result.entTabla[i].nombre
                                    }
                                    else {
                                        codigosRepetidos[result.entTabla[i].codigotelefono] = result.entTabla[i].nombre
                                    }
                                }
                            }

                            for (let i in codigosRepetidos) {
                                provincias.push({
                                    "value": i,
                                    "label": codigosRepetidos[i] + " - " + i
                                })
                            }

                            this.setState({
                                loading: false,
                                codigoAreaList: provincias
                            });


                        } else {
                            alertService.error("Ocurrió un error al obtener las provincias.")
                        }
                    },

                    (error) => {
                        this.setState({
                            loading: false,
                            error,
                            codigoAreaList: []
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )
        }


    }

    cargarCodigoArea(idProvincia, change = true) {
        var dto = this.state.dtoData;
        dto["idprovincia"] = idProvincia;
        if (change) {
            if (dto["tipotelefono"] !== "C") {
                dto["codigoarea"] = codigosArea[idProvincia];
                if (codigosArea[idProvincia] === "") {
                    this.setState({
                        readOnlyCodigoProvincia: false,
                    });
                }
                else {
                    this.setState({
                        readOnlyCodigoProvincia: true,
                    });
                }
            }

        }

        this.setState({
            dtoData: dto,
        });
    }

    handleSelectChangeTipo(tipo) {
        var dto = this.state.dtoData;
        dto["tipotelefono"] = tipo;
        var rocp;
        if (tipo === "C" && dto.codigopais === "593") {
            var dto = this.state.dtoData;
            dto["codigoarea"] = "09";
            rocp = true;
        }
        else if (dto.codigopais !== "593") {
            rocp = false;
        }
        this.setState({
            dtoData: dto,
            readOnlyCodigoProvincia: rocp
        });

    }

    handleSelectChange(value, name, tipo = null) {
        var dto = { ...this.state.dtoData };

        if (name === "codigopais") {
            dto["idpais"] = +value;

            var rocp;
            if (dto.tipotelefono === "C" && value === ID_PAIS_ECUADOR) {                
                dto["codigoarea"] = "09";
                rocp = true;
            }
            else if (value !== ID_PAIS_ECUADOR) {
                rocp = false;
                dto["codigoarea"] = "";
            }


            if (value !== ID_PAIS_ECUADOR) {

                const areaCodigo: Area_ID | undefined = this.state.matchidPaisArea.find(pa => pa.idpais == +value);

                if (!areaCodigo) {
                    alertService.error("Ha ocurrido un evento inesperado");
                    return;
                }
                else {
                    dto[name] = areaCodigo.codigoArea.trim();
                }
                
                this.setState({
                    dtoData: dto,
                    readOnlyCodigoProvincia: rocp
                });
            }
            else {
                
                this.setState({
                    dtoData: dto,
                    readOnlyCodigoProvincia: rocp
                });
            }

        }
        else {
            dto[name] = value;
            this.setState({ dtoData: dto });
        }

    }

    onClickEdit(idTelefono) {
        this.setState({
            dtoData: new TelefonosData()
        });
        fetch(API_URL + "DatosTelefono/TelefonoByIdTelefono/" + idTelefono)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        var dto = result.entTabla[0]
                        var roca = false;
                        if (dto["codigopais"] === "593" && dto["tipotelefono"] === "C") {
                            roca = true

                        }

                        this.setState({
                            dtoData: dto,
                            loading: false,
                            readOnlyCodigoProvincia: roca
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new TelefonosData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idTelefono) {
        fetch(API_URL + "FormularioController/DeleteDatosTelefono/" + idTelefono, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El teléfono se eliminó correctamente.")
                        this.cargarTelefonos();
                    }
                })
    }

    onClickLimpiar() {
        this.cargarCodigoPais("593", true);
        this.setState({
            dtoData: new TelefonosData()
        });

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({ dtoData: dto });
    }

    handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = { ...this.state.dtoData };



        const areaCodigo: Area_ID | undefined = this.state.matchidPaisArea.find(pa => pa.idpais == +dto["idpais"]);

        if (!areaCodigo) {
            alertService.error("Ha ocurrido un evento inesperado");
            return;
        }
        else {
            dto.codigopais = areaCodigo.codigoArea.trim();
        }





        //delete dto['ultimoCambio'];




        if (dto["codigopais"].length > 3) {
            alertService.error("Ocurrió un error: El código país debe contener máximo 3 dígitos.")
            return;
        }

        if (dto["codigoarea"].length > 3) {
            alertService.error("Ocurrió un error: El código área debe contener máximo 2 dígitos.")
            return;
        }

        if (dto["numerotelefono"].length > 8) {
            alertService.error("Ocurrió un error: El número de teléfono debe contener máximo 8 dígitos.")
            return;
        }

        if (dto["codigopais"] === "593") {
            if (dto["tipotelefono"] === "D") {
                if (dto["numerotelefono"].length !== 7) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener 7 dígitos.")
                    return;
                }
            }
            else if (dto["tipotelefono"] === "C") {
                if (dto["numerotelefono"].length !== 8) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener 8 dígitos.")
                    return;
                }
            }
            else {
                if (dto["numerotelefono"].length !== 7 && dto["numerotelefono"].length !== 8) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener de 7 a 8 dígitos.")
                    return;
                }
            }
        }

        forma.forEach((value, clave) => {

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(dto[clave]);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = dto[clave];

        });

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "ttelefono": dto
        });

        if (dto.idtelefono === 0) {
            fetch(API_URL + "FormularioController/PostDatosTelefono", {

                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,

            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error(mensajeCamposIncompletos())

                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("El teléfono se ha registrado correctamente.")
                            this.onClickLimpiar();
                            this.cargarTelefonos();
                            authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                        }
                        else {
                            alertService.error("Ocurrió un error: " + responseJson)
                        }

                    },
                    (error) => {
                        alertService.error("Ocurrió un error: " + error)
                    })
        }
        else {
            fetch(API_URL + "FormularioController/PutDatosTelefono", {

                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: data,

            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error(responseJson["strMensaje"])

                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("El teléfono se ha actualizado correctamente.")
                            this.onClickLimpiar();
                            this.cargarTelefonos();
                        }
                        else {
                            alertService.error("Ocurrió un error: " + responseJson)
                        }

                    },
                    (error) => {
                        alertService.error("Ocurrió un error: " + error)
                    })
        }
    }


    // This will handle Cancel button click event.  

    private handleCancel(e) {

        e.preventDefault();

        this.props.history.push("/fetch-contactos");

    }

    //handleChange(event) {
    //    var dto = this.state.dtoData;
    //    dto[event.target.name] = event.target.value;
    //    this.setState({
    //        dtoData: dto,
    //        loading: false
    //    })
    //}

    lengthValidation(event, maxLength) {
        var dto = { ...this.state.dtoData };
        
        dto[event.target.name] = event.target.value.substring(0, maxLength);
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.telefonosDataList, this.state.codigosPaisList, this.state.codigoAreaList, this.state.tiposTelefonoList);

        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(telefonosDataList: TelefonosData[], codigosPaisList: Array<any>, codigoAreaList: Array<any>, tiposTelefonoList) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">TELÉFONOS</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave} id="formTelefonos">
                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nombrecontacto">Tipo*</Label>
                                                    <SelectItem
                                                        options={tiposTelefono}
                                                        value={this.state.dtoData.tipotelefono}
                                                        placeholder=""
                                                        name="tipotelefono"
                                                        id="tipo"
                                                        //icon="fa-phone"
                                                        icon="telefono"
                                                        onChange={this.handleSelectChangeTipo}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="codigopais">Código país*</Label>
                                                    <SelectItem
                                                        options={codigosPaisList}
                                                        value={this.state.dtoData.idpais ? this.state.dtoData.idpais : ""}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="codigopais"
                                                        id="codigopais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {
                                                //<Col md={2}>
                                                //    <FormGroup>
                                                //        <Label for="idpais">Código país</Label>
                                                //        <FormGroup>
                                                //            <InputGroup>
                                                //                <Input type="number" step="1" min="1" max="999" name="codigopais" id="codigopais" value={this.state.dtoData.codigopais.trim()} required onChange={(e) => this.lengthValidation(e, 3)} readOnly={this.state.readOnlyCodigoPais} />
                                                //                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                //                    <Icon kind="pais" fill='#FFFFFF' width={27} height={27} />
                                                //                </InputGroupAddon>
                                                //            </InputGroup>
                                                //        </FormGroup>
                                                //    </FormGroup>
                                                //</Col>
                                            }


                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">Código área / estado*</Label>
                                                    {
                                                        this.state.dtoData.codigopais === "593" && this.state.dtoData.tipotelefono !== "C" ?
                                                            <SelectItem
                                                                options={codigoAreaList}
                                                                value={this.state.dtoData.codigoarea ? this.state.dtoData.codigoarea.trim() : ""}
                                                                onChange={this.handleSelectChange}
                                                                placeholder=""
                                                                name="codigoarea"
                                                                id="codigoarea"
                                                                icon="ubicacion"
                                                            />
                                                            :
                                                            <InputGroup>
                                                                <Input step="1" min="1" max="999" type="number" name="codigoarea" id="codigo_area" value={this.state.dtoData.codigoarea} required onChange={(e) => this.lengthValidation(e, 3)} readOnly={this.state.readOnlyCodigoProvincia} />
                                                                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                    <Icon kind="telefono_area" fill='#FFFFFF' width={27} height={27} />
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                    }
                                                </FormGroup>
                                            </Col>


                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="numerotelefono">Número*</Label>
                                                    <FormGroup>
                                                        <InputGroup>
                                                            <Input step="1" min="1" max="99999999" type="number" name="numerotelefono" id="numero" value={this.state.dtoData.numerotelefono} required onChange={(e) => this.lengthValidation(e, 8)} />
                                                            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                <Icon kind="numero" fill='#FFFFFF' width={27} height={27} />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <div className="form-group">
                                            <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                            <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                        </div >

                                    </form >
                                </div>
                                <br />
                                <br />
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>

                                        </div>
                                        :
                                        <Row id="lista">
                                            {telefonosDataList.map((dto, index) =>
                                                <CardTelefono
                                                    key={dto.idtelefono}
                                                    tipo={dto.tipotelefono}
                                                    codigo_pais={dto.codigopais}
                                                    codigo_area={dto.codigoarea}
                                                    numero={dto.numerotelefono}
                                                    number={(index + 1) + " / " + telefonosDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idtelefono)}
                                                    eventDelete={() => this.onClickDelete(dto.idtelefono)} />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}

export default Telefonos;